import React from "react";
import PropTypes from "prop-types";
import SendButton from "../../shared/SendButton/SendButton";
import ChatFormGoogleAdress from "../../../../containers/Chat/ChatFormGoogleAdress";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
//================ STEP 2 ===============
const HandleAddress = ({
																							messageValue,
																							addMessage,
																							addBotMessage,
																							inputDisabled,
																							setInputDisable,
																							loadingBotMessage,
																							responseBotDelay,
																							setStep,
																							updateCity,
																							updateZIPCode,
																							updateAdress,
																							handleChange,
																							userInfos,
																							setUserInfos
																							}) => {
const handleAdressSubmit = (e) => {
e.preventDefault();
if (messageValue === "") {
e.preventDefault();
} else {
if (!userInfos.route && !userInfos.cp && !userInfos.city) {
// Si l'utilisateur ne clique pas sur les suggestions proposées
// par l'autocomplétion de google address
e.preventDefault();
setUserInfos(messageValue, "route");
loadingBotMessage(true);
addMessage(messageValue);
setInputDisable(true);
setTimeout(() => {
loadingBotMessage(false);
addBotMessage("Il semble que vous n'ayez pas sélectionné une adresse parmi celles proposées. J'ai maintenant besoin du nom de votre ville ?", "bot");
setInputDisable(false);
setStep(2.1);
document.body.classList.remove("customHeight");
}, responseBotDelay);
} else {
// Si l'utilisateur a choisi une address suggérée par google address
loadingBotMessage(true);
e.preventDefault();
addMessage(messageValue);
// setUserInfos(messageValue, "lastname");
setInputDisable(true);
setTimeout(() => {
loadingBotMessage(false);
addBotMessage("Merci. Pour terminer, sur quel numéro de téléphone pouvons-nous vous joindre ?", "bot");
updateCity(),
updateAdress(),
updateZIPCode();
setInputDisable(false);
setStep(3);
document.body.classList.remove("customHeight");
}, responseBotDelay);
}
}
};
return (
<ContainerReponse>
<ChatFormGoogleAdress
onSubmit={handleAdressSubmit}
toggleFocusOn={inputDisabled}
type="text"
label="Tapez votre adresse"
value={messageValue}
onChange={handleChange}
valueToActive={messageValue}
disabled={inputDisabled ? "disabled" : ""}
required={true}
>
<SendButton disabled={inputDisabled || !messageValue ? "disabled" : ""}/>
</ChatFormGoogleAdress>
</ContainerReponse>
);
};

HandleAddress.propTypes = {
responseBotDelay: PropTypes.number,
setStep: PropTypes.func,
handleChange: PropTypes.func,
messageValue: PropTypes.string,
inputDisabled: PropTypes.bool,
addMessage: PropTypes.func,
addBotMessage: PropTypes.func,
setInputDisable: PropTypes.func,
setUserInfos: PropTypes.func,
loadingBotMessage: PropTypes.func,
updateCity: PropTypes.func,
updateZIPCode: PropTypes.func,
updateAdress: PropTypes.func,
userInfos: PropTypes.object,
};

export default HandleAddress;
